import React, { useState } from "react";
import { Box } from "@mui/material";
import {
  DataGrid,
  GridToolbar,
  GridFilterModel,
  GridColDef,
  GridColumnGroupingModel,
  GridRowsProp,
  GridColumnVisibilityModel,
} from "@mui/x-data-grid";

interface BuyerInfo {
  id: number;
  name: string;
  email: string;
  phoneNumber: string;
  identification: string;
}

interface TicketHolder {
  id: number;
  name: string;
  email: string;
  identification: string;
}

interface TicketVariant {
  id: number;
  name: string;
}

interface EventAttendee {
  id: number;
  purchaseDate: string;
  used: boolean;
  buyerInfo: BuyerInfo;
  ticketHolder: TicketHolder;
  ticketVariant: TicketVariant;
}

interface EventAttendeesTableProps {
  attendees: EventAttendee[] | undefined;
}

export const PlannerEventAttendees: React.FC<EventAttendeesTableProps> = ({
  attendees,
}) => {
  const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
    items: [],
    quickFilterExcludeHiddenColumns: true,
    quickFilterValues: [""],
  });
  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({
      buyerInfoName: false,
      buyerInfoEmail: false,
      buyerInfoIdentification: false,
      buyerInfoPhonenumber: false,
    });

  const columnGroupingModel: GridColumnGroupingModel = [
    {
      groupId: "Titular de la Entrada",
      children: [
        { field: "ticketHolderName" },
        { field: "ticketHolderEmail" },
        { field: "ticketHolderIdentification" },
      ],
    },
    {
      groupId: "Comprador de la Entrada",
      children: [
        { field: "buyerInfoName" },
        { field: "buyerInfoEmail" },
        { field: "buyerInfoIdentification" },
        { field: "buyerInfoPhonenumber" },
      ],
    },
  ];

  const columns: GridColDef[] = [
    { field: "ticketHolderName", headerName: "Nombre", width: 200 },
    { field: "ticketHolderEmail", headerName: "Correo", width: 200 },
    { field: "ticketHolderIdentification", headerName: "Identificacion", width: 150, headerAlign: 'center', align: 'center' },

    { field: "ticketVariantName", headerName: "Ticket", width: 100, headerAlign: 'center', align: 'center' },

    { field: "buyerInfoName", headerName: "Nombre", width: 200 },
    { field: "buyerInfoEmail", headerName: "Correo", width: 200 },
    { field: "buyerInfoIdentification", headerName: "Identificacion", width: 150,headerAlign: 'center', align: 'center' },
    { field: "buyerInfoPhonenumber", headerName: "Telefono", width: 150, headerAlign: 'center', align: 'center' },

    { field: "purchaseDate", headerName: "Fecha Compra", width: 200, type: "date", headerAlign: 'center', align: 'center' },
    { field: "used", headerName: "Activado", width: 80, type: "boolean" },
  ];

  const rows: GridRowsProp = attendees?.map((attendee) => ({
    id: attendee.id,
    purchaseDate: new Date(attendee.purchaseDate.split("Z")[0]),
    used: attendee.used,
    buyerInfoName: attendee.buyerInfo.name,
    buyerInfoEmail: attendee.buyerInfo.email,
    buyerInfoIdentification: attendee.buyerInfo.identification,
    buyerInfoPhonenumber: attendee.buyerInfo.phoneNumber,
    ticketHolderName: attendee.ticketHolder.name,
    ticketHolderEmail: attendee.ticketHolder.email,
    ticketHolderIdentification: attendee.ticketHolder.identification,
    ticketVariantName: attendee.ticketVariant.name,
  })) ?? [];

  return (
    <Box sx={{ height: "60vh", width: "100%" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        sx={{ padding: "10px"}}
       
        slots={{ toolbar: GridToolbar }}
        filterModel={filterModel}
        onFilterModelChange={(newModel) => setFilterModel(newModel)}
        columnGroupingModel={columnGroupingModel}
        localeText={{
          noRowsLabel: "No hay filas",
          noResultsOverlayLabel: "No se encontraron resultados.",

          toolbarColumns: "Columnas",
          toolbarColumnsLabel: "Selecciona columnas",

          toolbarFilters: "Filtros",
          toolbarFiltersLabel: "Mostrar filtros",
          toolbarFiltersTooltipHide: "Ocultar filtros",
          toolbarFiltersTooltipShow: "Mostrar filtros",
          filterPanelAddFilter: "Agregar filtro",
          filterPanelRemoveAll: "Eliminar todos",
          filterPanelDeleteIconLabel: "Eliminar",
          filterPanelLogicOperator: "Operador lógico",
          filterPanelOperatorAnd: "Y",
          filterPanelOperatorOr: "O",
          filterPanelColumns: "Columnas",
          filterPanelInputLabel: "Valor",
          filterPanelOperator: "Operador",
          filterPanelInputPlaceholder: "Filtrar valor",

          toolbarQuickFilterPlaceholder: "Buscar",

          toolbarExport: "Exportar",
          toolbarExportLabel: "Exportar",
          toolbarExportCSV: "Descargar como CSV",
          toolbarExportPrint: "Imprimir",

          toolbarDensity: "Densidad",
          toolbarDensityLabel: "Densidad",
          toolbarDensityCompact: "Compacta",
          toolbarDensityStandard: "Estándar",
          toolbarDensityComfortable: "Cómoda",

          columnMenuLabel: "Menú",
          columnMenuShowColumns: "Mostrar columnas",
          columnMenuFilter: "Filtrar",
          columnMenuHideColumn: "Ocultar",
          columnMenuUnsort: "Desordenar",
          columnMenuSortAsc: "Orden ascendente",
          columnMenuSortDesc: "Orden descendente",
        }}
        slotProps={{ toolbar: { showQuickFilter: true } }}
        columnVisibilityModel={columnVisibilityModel}
        onColumnVisibilityModelChange={(newModel) =>
          setColumnVisibilityModel(newModel)
        }
      />
    </Box>
  );
};

